import React from 'react';

import CompanyList from '../../components/Admin/CompanyList';

function CompanyListView() {
  return (
    <CompanyList />
  );
}

export default CompanyListView;
